import apiClient from './api-client';
import authHeader from './auth-header';
import { API_URL } from '@/config/runtime';
import { clearStoredUser, setStoredUser } from './session';

export { API_URL };

const register = (firstName, lastName, email, password) => apiClient.post('register', {
  firstName, lastName, email, password,
  // confirmPassword
});
const verifyOtp = (otp, email) => apiClient.post('varifyOtp', {
  otp, email,
});
const resendOtp = email => apiClient.post('resendOtp', {
  email,
});
const forgetPass = email => apiClient.post('forgotPassword', {
  email,
});
const changePassword = (password, newPassword, otp) => apiClient.post('changePassword', {
  password,
  newPassword,
  otp,
}, { headers: authHeader() });
const login = async (email, password, captchaToken) => apiClient
  .post('login', {
    email,
    password,
    role:'admin',
    recaptcha_token: captchaToken
  })
  .then((response) => {
    setStoredUser(response.data);

    return response.data;
  });

const logout = () => {
  clearStoredUser();
};
export const sendToken = async (amount, receiver, coin, otp) => apiClient
  .post('sendToken', {
    amount,
    receiver,
    coin,
    otp,
  }, { headers: authHeader() });
const varifyPasswordotp = (email, otp) => apiClient.post('varifyPasswordotp', {
  email, otp,
});
const resetPassword = (email, otp, password, confirmPassword) => apiClient.post('resetPassword', {
  email, otp, password, confirmPassword,
});
const verifyTwoFactor = (otp, email) => apiClient.post('varify_2fa_otp', {
  otp, email,
}, { headers: authHeader() })
  .then((response) => {
    setStoredUser(response.data);

    return response.data;
  });
export default {
  register,
  login,
  forgetPass,
  logout,
  verifyOtp,
  resendOtp,
  // sendToken,
  changePassword,
  resetPassword,
  varifyPasswordotp,
  verifyTwoFactor,
};
